import React from "react";
import { makeStyles } from '@material-ui/core/styles';

import IcCheckSquare from "../../../../resources/svgs/ic_check_square.svg";

import Container from "../../../../base/components/container.js";
import HtmlContent from "../../../../base/components/html_content.js";
import I18n from "../../../../base/i18n.js.jsx";

import IlHouse from "../resources/illustrations/il_house.js"

const desktopBulletSide = 36;
const padBulletSide = 28;
const phoneBulletSide = 20;

const blockStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.blueBg,
  },
  content: {
    padding: "50px 16px 70px",
    ['@media (max-width: 992px)']: {
      padding: "40px 16px 50px",
    },
    ['@media (max-width: 768px)']: {
      padding: "32px 24px 40px",
    },
  },
  innerContent: {
    display: "flex",
    ['@media (max-width: 768px)']: {
      flexWrap: "wrap",
    },
  },
  contentColumn: {
    marginRight: "5px",
    flex: 1,
    ['@media (max-width: 768px)']: {
      marginRight: "0px",
    },
  },
  imageColumn: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    ['@media (max-width: 768px)']: {
      marginTop: "30px",
      width: "100%"
    },
  },
  ilHouse: {
    width: "402px",
    height: "auto",
    display: "block",
    ['@media (max-width: 1199px)']: {
      width: "300px"
    },
    ['@media (max-width: 992px)']: {
      width: "260px"
    },
    ['@media (max-width: 768px)']: {
      width: "57%",
    }
  },
  titleDesktop: {
    display: "block",
    fontSize: "38px",
    textTransform: "uppercase",
    marginBottom: "30px",
    ['@media (max-width: 992px)']: {
      fontSize: "28px",
      lineHeight: "30px",
      marginBottom: "20px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "20px",
      lineHeight: "24px",
      marginBottom: "20px",
    },
    ['@media (max-width: 576px)']: {
      display: "none"
    }
  },
  titleMobile: {
    fontSize: "20px",
    lineHeight: "24px",
    marginBottom: "20px",
    display: "block",
    textTransform: "uppercase",
    display: "none",
    ['@media (max-width: 576px)']: {
      display: "block"
    }
  },
  text: {
    display: "block",
    fontWeight: theme.typography.fontWeightLight,
    fontSize: "20px",
    marginBottom: "36px",
    ['@media (max-width: 992px)']: {
      fontSize: "18px",
      lineHeight: "26px",
      marginBottom: "30px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
      lineHeight: "20px",
      marginBottom: "21px",
    },
  },
  listTitle: {
    display: "block",
    fontSize: "28px",
    textTransform: "uppercase",
    marginBottom: "20px",
    ['@media (max-width: 992px)']: {
      fontSize: "22px",
      marginBottom: "18px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "16px",
      lineHeight: "18px",
      marginBottom: "16px",
    },
  },
  list: {
    marginTop: "0px",
    marginBottom: "0px",
    paddingLeft: "85px",
    ['@media (max-width: 992px)']: {
      paddingLeft: "68px",
    },
    ['@media (max-width: 768px)']: {
      paddingLeft: "52px",
    },
    "& li": {
      position: "relative",
      listStyleType: "none",
      fontSize: "20px",
      marginBottom: "14px",
      minHeight: `${desktopBulletSide}px`,
      display: "flex",
      alignItems: "center",
      ['@media (max-width: 992px)']: {
        fontSize: "18px",
        lineHeight: "20px",
        marginBottom: "14px",
        minHeight: `${padBulletSide}px`,
      },
      ['@media (max-width: 768px)']: {
        fontSize: "14px",
        lineHeight: "18px",
        marginBottom: "12px",
        minHeight: `${phoneBulletSide}px`,
      },
    },
    "& li:before": {
      content: '" "',
      position: "absolute",
      background: `url(${IcCheckSquare}) no-repeat`,
      height: `${desktopBulletSide}px`,
      width: `${desktopBulletSide}px`,
      left: `-${20 + desktopBulletSide}px`,
      backgroundSize: `${desktopBulletSide}px ${desktopBulletSide}px`,
      ['@media (max-width: 992px)']: {
        left: `-${18 + padBulletSide}px`,
        backgroundSize: `${padBulletSide}px ${padBulletSide}px`,
        height: `${padBulletSide}px`,
        width: `${padBulletSide}px`,
      },
      ['@media (max-width: 768px)']: {
        left: `-${16 + phoneBulletSide}px`,
        backgroundSize: `${phoneBulletSide}px ${phoneBulletSide}px`,
        height: `${phoneBulletSide}px`,
        width: `${phoneBulletSide}px`,
      },
    },
    "& li:last-child": {
      marginBottom: "0px"
    }
  },
  listItem: {
    display: "block"
  }
}));

const InvestInfoBlock = () => {
  const classes = blockStyles();

  return (
    <div className = { classes.root } >
      <Container className = { classes.content } >
        <HtmlContent className = { classes.titleDesktop } >
          { I18n.t("web.page.index.invest_info.title_desktop") }
        </HtmlContent>
        <HtmlContent className = { classes.titleMobile } >
          { I18n.t("web.page.index.invest_info.title_mobile") }
        </HtmlContent>
        <div className = { classes.innerContent } >
          <div className = { classes.contentColumn } >
            <HtmlContent className = { classes.text } >
              { I18n.t("web.page.index.invest_info.text") }
            </HtmlContent>
            <span className = { classes.listTitle } >
              { I18n.t("web.page.index.invest_info.list_title") }
            </span>
            <ul className = { classes.list } >
              {
                I18n.t("web.page.index.invest_info.list").map((text, index) => {
                  return <li key = { index } >
                    <span className = { classes.listItem } >
                      { text }
                    </span>
                  </li>
                })
              }
            </ul>
          </div>
          <div className = { classes.imageColumn } >
            <IlHouse className = { classes.ilHouse } />
          </div>
        </div>
      </Container>
    </div>
  )
}

export default InvestInfoBlock;
